import { GetContactType as ApiContactType } from 'src/api/generated/touring/types';
import { ContactType } from 'src/api/mapping/common';

export const mapContact = (contact: ApiContactType): ContactType => {
  return {
    phone: contact.phone,
    mobile: contact.mobile,
    email: contact.email,
    fax: contact.fax,
  };
};
